import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, ArrowLeft, Search, Mail } from 'lucide-react'
import SEO from '@components/SEO'

const NotFound = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: 'easeOut' }
  }

  return (
    <div className="pt-14 min-h-screen bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 text-white flex items-center justify-center">
      <SEO 
        title="Page Not Found - Total Rewards Pro"
        description="The page you're looking for doesn't exist. Return to Total Rewards Pro for strategic compensation and benefits consulting services."
        noIndex={true}
      />
      
      <div className="absolute inset-0 pattern-dots opacity-10"></div>
      
      <div className="max-w-4xl mx-auto w-full px-6 sm:px-8 lg:px-12 text-center relative">
        <motion.div
          initial="initial"
          animate="animate"
          variants={{
            animate: {
              transition: {
                staggerChildren: 0.1
              }
            }
          }}
        >
          <motion.div 
            className="mb-8"
            variants={fadeInUp}
          >
            <div className="text-8xl lg:text-9xl font-bold text-primary-500 mb-4">404</div>
            <h1 className="text-display-2 text-white mb-4">Page Not Found</h1>
            <p className="text-body-large text-neutral-200 max-w-2xl mx-auto">
              The page you're looking for doesn't exist or has been moved. Let's get you back on track.
            </p>
          </motion.div>

          <motion.div 
            className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12"
            variants={fadeInUp}
          >
            <Link 
              to="/" 
              className="card-premium p-6 text-center group hover:scale-105 transition-transform duration-300"
            >
              <Home className="w-8 h-8 text-primary-500 mx-auto mb-4" />
              <h3 className="text-heading-2 text-navy-900 mb-2">Go Home</h3>
              <p className="text-body-small text-muted">Return to our homepage</p>
            </Link>

            <Link 
              to="/services" 
              className="card-premium p-6 text-center group hover:scale-105 transition-transform duration-300"
            >
              <Search className="w-8 h-8 text-primary-500 mx-auto mb-4" />
              <h3 className="text-heading-2 text-navy-900 mb-2">Our Services</h3>
              <p className="text-body-small text-muted">Explore our consulting services</p>
            </Link>

            <Link 
              to="/contact" 
              className="card-premium p-6 text-center group hover:scale-105 transition-transform duration-300"
            >
              <Mail className="w-8 h-8 text-primary-500 mx-auto mb-4" />
              <h3 className="text-heading-2 text-navy-900 mb-2">Contact Us</h3>
              <p className="text-body-small text-muted">Get in touch with our team</p>
            </Link>
          </motion.div>

          <motion.div 
            className="flex flex-col sm:flex-row gap-4 justify-center"
            variants={fadeInUp}
          >
            <Link 
              to="/" 
              className="btn-accent"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
            <Link 
              to="/contact" 
              className="btn-secondary bg-white/10 border-white/30 text-white hover:bg-white/20"
            >
              Report Issue
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  )
}

export default NotFound 